import { render, staticRenderFns } from "./RevisionContainer.vue?vue&type=template&id=35391e8b&scoped=true"
import script from "./RevisionContainer.vue?vue&type=script&lang=js"
export * from "./RevisionContainer.vue?vue&type=script&lang=js"
import style0 from "./RevisionContainer.vue?vue&type=style&index=0&id=35391e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35391e8b",
  null
  
)

export default component.exports